module.exports = __webpack_public_path__ + "static/media/TN.d35ada5e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svgs/flags/TN.svg
// module id = 376
// module chunks = 0